import { useContext } from 'react';

import { StatsigExperimentContext } from '../context/NavSearchContext';

interface ConversationalSearchEntryPoint {
    /** Show the dedicated conversational-search CTA button (the experiment's `button` arm). */
    showButton: boolean;
    /** Show the in-bar AI toggle (the control and every other non-`button` arm). */
    showToggle: boolean;
}

/**
 * Resolves how conversational search is surfaced for a user who has access to it, based on the
 * discoverability experiment: the `button` arm swaps the in-bar toggle for a dedicated CTA, while
 * every other arm (including the control) keeps the toggle. Shared by ProminentSearch and its
 * legacy twin so the routing logic can't drift between them.
 */
export function useConversationalSearchEntryPoint(
    showConversationalSearchCta: boolean,
): ConversationalSearchEntryPoint {
    const { conversationalSearchDiscoverability } = useContext(StatsigExperimentContext);
    const entryPoint = conversationalSearchDiscoverability?.entryPoint ?? 'toggle';

    return {
        showButton: showConversationalSearchCta && entryPoint === 'button',
        showToggle: showConversationalSearchCta && entryPoint !== 'button',
    };
}
